import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import '../styles/Gallery.css';

class Gallery extends React.Component {

  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      image: PropTypes.any.isRequired,
      title: PropTypes.node,
      description: PropTypes.node
    })).isRequired,
    onUpdateIdx: PropTypes.func,
    metricsName: PropTypes.string
  };

  static defaultProps = {
    onUpdateIdx: () => {}
  };

  state = {
    selectedIdx: 0
  };

  render() {
    return (
      <div className={classnames('Gallery', this.props.className)}>
        <div className="Gallery-items">
          {
            this.props.items.map(({ image, title }, idx) => (
              <div
                key={idx}
                className={classnames('Gallery-item', {
                  selected: idx === this.state.selectedIdx
                })}
                onClick={this._onClickItem.bind(this, (this.state.selectedIdx + 1) % this.props.items.length)}>
                <div
                  className="Gallery-itemImg"
                  style={{
                    backgroundImage: `url(${image})`
                  }}
                />
              </div>
            ))
          }
        </div>
        <div className="Gallery-selector">
          {
            this.props.items.map((_, idx) => (
              <div
                key={idx}
                className={classnames('Gallery-dot', {
                  selected: idx === this.state.selectedIdx
                })}
                onClick={this._onClickItem.bind(this, idx)}
              />
            ))
          }
        </div>
        <div className="Gallery-labels">
          {
            this.props.items.map(({ title, description }, idx) => (
              <div
                key={idx}
                className={classnames('Gallery-label', {
                  selected: idx === this.state.selectedIdx
                })}>
                {
                  title &&
                  <h4 className="Gallery-itemTitle">
                    {title}
                  </h4>
                }
                {
                  description &&
                  <p className="Gallery-itemDescription">
                    {description}
                  </p>
                }
              </div>
            ))
          }
        </div>
      </div>
    );
  }

  _onClickItem = (idx) => {
    window.mixpanel.track('Selected gallery', {
      name: this.props.metricsName,
      index: idx
    });

    this.setState({
      selectedIdx: idx
    });
    this.props.onUpdateIdx(idx);
  };

}

export default Gallery;


// WEBPACK FOOTER //
// ./src/components/Gallery.js